import { Tooltip } from '@shape-ds/components';
import SapNoteStatus, { SapKeys, sapNotesOrder } from 'components/SapNotesStatus/SapNoteStatus';
import { ExternalReferenceSummary as ExternalReferenceSummaryType } from 'queries/cases/types';
import { SapNoteCriticalLevel } from 'queries/externalReferences/contract';
import { useTranslation } from 'react-i18next';
import './ExternalReferenceSummary.scss';

interface Props {
  summary?: ExternalReferenceSummaryType;
}

export const ExternalReferenceSummary = ({ summary }: Props) => {
  const { t } = useTranslation();

  const sortedReferences = summary
    ? Object.entries(summary).sort(
        (a, b) => sapNotesOrder[b[0] as SapKeys] - sapNotesOrder[a[0] as SapKeys],
      )
    : [];

  if (!summary || sortedReferences.length === 0) return '-';

  const flatReferences = sortedReferences.flatMap(([name, value]) => Array(value).fill(name));
  const shouldCollapse = flatReferences.length > 4;
  const references = shouldCollapse ? flatReferences.slice(0, 4) : flatReferences;

  const tooltip = (
    <>
      <div className="tooltip-title">{t('case:externalReference.title')}</div>
      {sortedReferences.map(([name, value]) => {
        const word = value > 1 ? 'plural' : 'singular';
        const lowercase = name.toLowerCase();
        const i18nValue = t('case:externalReference.' + lowercase);
        const capitalize = i18nValue.charAt(0) + i18nValue.slice(1);
        return (
          <div>
            {t('case:externalReference.tooltip.' + word, { value })}
            <span className={`reference-status ${lowercase}`}>{capitalize}</span>
          </div>
        );
      })}
    </>
  );

  return (
    <Tooltip title={tooltip} followCursor={false} className="tooltip-external-reference">
      <div className="external-reference-summary">
        {references.map((name, idx) => (
          <SapNoteStatus key={idx} status={name as SapNoteCriticalLevel} showCode={false} />
        ))}

        {shouldCollapse && <div className="plus-icon">+</div>}
      </div>
    </Tooltip>
  );
};
